export default [
  { naoNulo: true, tipo: 'string', atributo: 'conta.nome', nome: 'Conta' },
  { tipo: 'string', atributo: 'historico', nome: 'Histórico' },
  { naoNulo: true, tipo: 'numero', atributo: 'valor', nome: 'Valor' },
  { naoNulo: true, tipo: 'data', atributo: 'data', nome: 'Data' },
];
